module.exports = __webpack_public_path__ + "img/ArthurCruz.c845b7e4.jpg";